import { Form, FormInstance, Select, Typography } from "antd";
import { useEffect } from "react";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";

const { Option } = Select;

interface ISelectWalletProps {
  isTablet: boolean;
  form: FormInstance<any>;
  listWalletProvider: any[];
  walletSelectedProvider: any;
  setWalletSelectedProvider: React.Dispatch<any>;
  paramsWalletProvider: {
    start: number;
    end: number;
  };
  setParamsWalletProvider: React.Dispatch<
    React.SetStateAction<{
      start: number;
      end: number;
    }>
  >;
  companyDefaultSelected: any;
}

const SelectWalletProvider = (props: ISelectWalletProps) => {
  const {
    isTablet,
    form,
    listWalletProvider,
    walletSelectedProvider,
    setWalletSelectedProvider,
    paramsWalletProvider,
    setParamsWalletProvider,
    companyDefaultSelected,
  } = props;

  // Auto-fill when there's exactly 1 wallet provider
  useEffect(() => {
    if (Array.isArray(listWalletProvider) && listWalletProvider?.length === 1) {
      const singleProvider = listWalletProvider[0];
      setWalletSelectedProvider(singleProvider);
      form.setFieldsValue({ providerWallet: singleProvider.id });
    } else {
      setWalletSelectedProvider(null);
      form.setFieldsValue({ providerWallet: null });
    }
  }, [listWalletProvider, companyDefaultSelected]);

  return (
    <div className="director-transfer-bank">
      <Typography style={{ fontSize: 12, color: "white" }}>
        Provider Wallet Address
      </Typography>
      <Form.Item
        name={"providerWallet"}
        rules={[{ required: true, message: "This field is required" }]}
      >
        <Select
          showSearch
          disabled={!listWalletProvider.length}
          popupClassName="select-beneficiary"
          className="select-provider-bank select-recipient"
          suffixIcon={<ArrowIcon />}
          optionLabelProp="label"
          onChange={(id) => {
            const selected = listWalletProvider?.find(
              (item: any) => item.id === id
            );
            setWalletSelectedProvider(selected);
          }}
          filterOption={(input, option: any) => {
            const wallet = listWalletProvider.find(
              (w) => w.id === option.value
            );
            return (
              wallet?.name?.toLowerCase().includes(input.toLowerCase()) ||
              wallet?.address?.includes(input.toLowerCase())
            );
          }}
        >
          {Array.isArray(listWalletProvider) &&
            listWalletProvider.map((item: any) => (
              <Option
                key={item.id}
                value={item.id}
                label={
                  <span className="ant-select-custom-value-sendmoney">
                    {item.address}
                  </span>
                }
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span className="ant-select-custom-value-sendmoney">
                    {item.address}
                  </span>
                  <span style={{ fontWeight: 400, fontSize: "12px" }}>
                    {item.name}
                  </span>
                </div>
                {walletSelectedProvider?.id === item.id && <CheckSelectIcon />}
              </Option>
            ))}
          {listWalletProvider.length === paramsWalletProvider.end && (
            <Option key="load-more">
              <span
                style={{
                  fontSize: isTablet ? 12 : 14,
                  color: "rgba(29, 171, 241, 1)",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setParamsWalletProvider((prev) => ({
                    ...prev,
                    end: prev.end + 10,
                  }));
                }}
              >
                Load more <img src={Arrowdown} />
              </span>
            </Option>
          )}
        </Select>
      </Form.Item>
      {form.getFieldValue("companies_default") ? null : (
        <Typography
          style={{
            fontSize: isTablet ? 10 : 12,
            fontWeight: 400,
            color: "#EC3333",
          }}
        >
          {"Please select a provider before choosing a wallet address."}
        </Typography>
      )}
      {walletSelectedProvider ? (
        <>
          <Typography style={{ fontSize: 12, color: "white" }}>
            Currency: {walletSelectedProvider?.assetConfig?.symbol}
          </Typography>
          <Typography style={{ fontSize: 12, color: "white" }}>
            Network: {walletSelectedProvider?.network?.name}
          </Typography>
        </>
      ) : null}
    </div>
  );
};

export default SelectWalletProvider;
